import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DashboardGroup} from '@models/dashboard/dashboard-group';

@Component({
    selector: 'scitis-dashboard-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    standalone: false
})
export class GroupComponent {
  private gap: number = 15;
  private minW: number = 300;

  @Input()
  parentGroup: DashboardGroup | any;
  @Input() set groups(groups: DashboardGroup[]) {
    this.availableGroups = groups?.map(group => ({ ...group, statusGroupPageData: { ...group.statusGroupPageData } })) || [];
  }
  @Output() loadMoreMachineGroupsDataForStatusPage: EventEmitter<boolean> = new EventEmitter<boolean>();

  availableGroups: DashboardGroup[] = [];

  areGroupsExpanded: boolean = false;

  shouldShowExpandButton(): boolean {
    if (!this.availableGroups) {
      return false;
    }
    const gridArea = document.querySelector<HTMLElement>('.grid-groups');
    if (gridArea != null) {
      const gridAreaWidth = gridArea.offsetWidth;
      const itemsPerRow = Math.floor((gridAreaWidth + this.gap) / (this.minW + this.gap));
      return this.availableGroups.length > itemsPerRow;
    }
    return false;
  }

  onSwitchGroupExpandedState(): void {
    this.areGroupsExpanded = !this.areGroupsExpanded;
    if (this.areGroupsExpanded) {
      this.loadMoreMachineGroupsDataForStatusPage.emit(true);
    }
  }

  // Allows updating only those elements that have changed, instead of rebuilding the entire list
  trackByFn(index: number, item: DashboardGroup): any {
    return item.groupId;
  }
}
